import _ from 'lodash'

export const getFilteredSortedFields = (entityType) => {
  const fieldsFiltered = [
    ...(entityType.data?.fields ?? []),
    ...(entityType.data?.tenantFields ?? [])
  ].filter((f) => !_.get(f, 'field_data.belongs_to_matrix', false))

  const fieldsSorted = _.sortBy(fieldsFiltered, (f) => {
    return _.get(f, 'field_data.sort_order', 999)
  })

  return fieldsSorted
}
